import React, { useEffect, useState } from "react";

const fallbackConfirm = (message) => Promise.resolve(window.confirm(message));

if (typeof window !== "undefined" && typeof window.confirmDialog !== "function") {
  window.confirmDialog = fallbackConfirm;
}

export function ConfirmDialogHost() {
  const [dialog, setDialog] = useState({
    isOpen: false,
    message: "",
    title: "Confirm Action",
    resolve: null
  });

  useEffect(() => {
    window.confirmDialog = (message, title = "Confirm Action") =>
      new Promise((resolve) => {
        setDialog({
          isOpen: true,
          message,
          title,
          resolve
        });
      });

    return () => {
      window.confirmDialog = fallbackConfirm;
    };
  }, []);

  const close = (result) => {
    if (dialog.resolve) {
      dialog.resolve(result);
    }
    setDialog({
      isOpen: false,
      message: "",
      title: "Confirm Action",
      resolve: null
    });
  };

  if (!dialog.isOpen) return null;

  return (
    <div className="confirm-modal-backdrop" role="presentation">
      <div className="confirm-modal" role="dialog" aria-modal="true" aria-label={dialog.title}>
        <h3>{dialog.title}</h3>
        <p>{dialog.message}</p>
        <div className="confirm-modal-actions">
          <button type="button" className="btn btn-ghost" onClick={() => close(false)}>
            Cancel
          </button>
          <button type="button" className="btn btn-primary" onClick={() => close(true)}>
            Yes, Continue
          </button>
        </div>
      </div>
    </div>
  );
}
